module.exports = __webpack_public_path__ + "static/media/staff1.56a44a26.png";